import { useEffect } from 'react'

/**
 * Calls `onClose` when the Escape key is pressed.
 * Add to any modal component: useEscapeKey(onClose)
 */
export function useEscapeKey(onClose: () => void) {
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    document.addEventListener('keydown', handler)
    return () => document.removeEventListener('keydown', handler)
  }, [onClose])
}
